<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.12953 9.6693C7.12953 9.12242 7.19594 8.68688 7.32875 8.36266C7.46156 8.03844 7.70473 7.7191 8.05824 7.40465C8.41176 7.09019 8.64711 6.83434 8.7643 6.63707C8.88148 6.4398 8.94008 6.2318 8.94008 6.01305C8.94008 5.35289 8.63539 5.02281 8.02602 5.02281C7.73695 5.02281 7.50551 5.11168 7.33168 5.28941C7.15785 5.46715 7.06703 5.71226 7.05922 6.02477H5.36C5.36781 5.27867 5.60902 4.69469 6.08363 4.27281C6.55824 3.85094 7.2057 3.64 8.02602 3.64C8.85415 3.64 9.49672 3.84019 9.95375 4.24059C10.4108 4.64098 10.6393 5.2064 10.6393 5.93688C10.6393 6.26891 10.5651 6.58238 10.4166 6.87731C10.2682 7.17223 10.0084 7.49937 9.63734 7.85875L9.16273 8.30992C8.86586 8.59508 8.69594 8.92906 8.65297 9.31188L8.62953 9.6693H7.12953ZM6.95961 11.4681C6.95961 11.2064 7.04848 10.9906 7.22621 10.8207C7.40395 10.6507 7.63148 10.5658 7.90883 10.5658C8.18617 10.5658 8.41371 10.6507 8.59145 10.8207C8.76918 10.9906 8.85805 11.2064 8.85805 11.4681C8.85805 11.7259 8.77113 11.9388 8.59731 12.1068C8.42348 12.2748 8.19399 12.3588 7.90883 12.3588C7.62367 12.3588 7.39418 12.2748 7.22035 12.1068C7.04652 11.9388 6.95961 11.7259 6.95961 11.4681Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HelpIcon',
  props: {
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
